<div class="price-wrapper">
  <div class="price-container">
    <!-- Desktop view: separate whole and decimal parts -->
    <ng-container *ngIf="!shouldShowPriceNotation">
      <span class="price-whole"
            [ngClass]="{'desktop': priceComparison}"
            matTooltipPosition="above">
        {{ (currencySymbol + priceParts.whole) | priceNotation }}
      </span>
      <span class="price-decimal"
            [ngClass]="{'desktop': priceComparison}"
            *ngIf="!shouldHideDecimal && priceParts.decimal"
            matTooltipPosition="above">
        {{ priceParts.decimal }}
      </span>
      <span class="price-whole mobile"
            *ngIf="priceComparison"
            [matTooltip]="shouldShowPriceNotation ? fullPriceForTooltip : null"
            matTooltipPosition="above">
        {{ (currencySymbol + priceParts.whole + (priceParts.decimal ? '.' + priceParts.decimal : '')) | priceNotation }}
      </span>
    </ng-container>

    <!-- Mobile view (< 800px): show price with notation -->
    <span class="price-whole mobile-notation clickable"
          *ngIf="shouldShowPriceNotation"
          [matTooltip]="null"
          [matTooltipDisabled]="true"
          matTooltipPosition="above"
          (click)="showTooltipOnMobile($event)">
      {{ formattedPriceWithNotation }}
    </span>
    <!-- Inline label only for singular user in comparison view -->
    <span class="recurrence-label" *ngIf="priceComparison && !(userCount && userCount > 1)">
      {{ (simpleRecurrenceLabel ? 'common.user' : 'common.perUser') | translate }} / {{ 'billing.month' | translate }}
    </span>
    <span class="recurrence-label-mobile" *ngIf="priceComparison && !(userCount && userCount > 1)">
      {{ (simpleRecurrenceLabel ? 'common.user' : 'common.perUser') | translate }} / {{ 'billing.shortMonth' | translate }}
    </span>
    <!-- Inline label for V2 plan cards -->
    <ng-container *ngIf="inlineLabel && !priceComparison">
      <span class="recurrence-label inline-plan-label" *ngIf="!(userCount && userCount > 1)">
        {{ (simpleRecurrenceLabel ? 'common.user' : 'common.perUser') | translate }} / {{ 'billing.month' | translate }}
      </span>
      <span class="recurrence-label inline-plan-label" *ngIf="userCount && userCount > 1">
        {{ 'billing.perUsersPerMonth' | translate: { count: userCount } }}
      </span>
    </ng-container>
  </div>
  <div class="recurrence-label-container" *ngIf="!priceComparison && !inlineLabel">
    <span class="recurrence-label" *ngIf="!priceComparison">
      <ng-container *ngIf="!(userCount && userCount > 1); else pluralLabel">
        {{ (simpleRecurrenceLabel ? 'common.user' : 'common.perUser') | translate }} / {{ 'billing.month' | translate }}
      </ng-container>
      <ng-template #pluralLabel>
        {{ 'billing.perUsersPerMonth' | translate: { count: userCount } }}
      </ng-template>
    </span>
  </div>
  <div class="billed-messages-container" *ngIf="!hideRecurrenceMessage">
    <span class="recurrence-description">{{ 'billing.billedRecurrence' | translate: { amount: plan.pricePerRecurrence } }}</span>
  </div>
</div>
